<template>
  <div v-if="visible">
    <a
      :href="params.value.Link"
      target="_blank"
      class="text-blue-500 underline"
    >
      ${{ params.value.Price }}
    </a>
  </div>
</template>

<script>
export default {
  name: "ShopifyFGTLink",
  computed: {
    visible() {
      return Boolean(this.params.value.Link && this.params.data.Active_FGT);
    }
  }
};
</script>
